import React from 'react';
import { CHANNEL_ICONS } from './composer/ChannelPicker';
import { CHANNELS } from './reminderUi';

/**
 * Small views the history, the campaign page and the rules share.
 */

export const CAMPAIGN_STATUS_TONE = {
  SCHEDULED: 'info',
  SENDING: 'warning',
  SENT: 'success',
  CANCELLED: 'neutral',
  FAILED: 'danger',
};

export const DELIVERY_STATUS_TONE = {
  SENT: 'success',
  FAILED: 'danger',
  SKIPPED: 'neutral',
};

/** True while a campaign is still going out: being sent, or due within the minute (the queue picks it up in a second or two). */
export function isInFlight(campaign, now = Date.now()) {
  if (!campaign) return false;
  if (campaign.status === 'SENDING') return true;
  if (campaign.status !== 'SCHEDULED' || !campaign.scheduledAt) return false;
  const at = new Date(campaign.scheduledAt).getTime();
  return !Number.isNaN(at) && at <= now + 60 * 1000;
}

/**
 * The channels of a campaign as a row of small icons, each named for screen readers and as a
 * tooltip. `t` is the page's translate function.
 */
export function ChannelIcons({ channels, t, className = '' }) {
  const list = CHANNELS.filter((key) => Array.isArray(channels) && channels.includes(key));
  if (list.length === 0) return <span className="rem-muted">—</span>;
  return (
    <ul className={`rem-channel-icons ${className}`.trim()}>
      {list.map((key) => {
        const Icon = CHANNEL_ICONS[key];
        const label = t(`reminders.channel.${key}`);
        return (
          <li key={key} title={label}>
            <Icon aria-hidden="true" />
            <span className="visually-hidden">{label}</span>
          </li>
        );
      })}
    </ul>
  );
}
